/**
 * Created by lycheng on 2019/9/5.
 */

import Experience from './utils-tts-experience'
import { exLists } from 'js/config/read_solution_exlist'

const DEFAULT_TEXT = '科大讯飞成立于1999年，是中国先进的智能化语音技术提供商。我们提供的语音合成效果，达到了真正可商用的标准，您可以在这里输入任意文本进行语音合成体验。'

var experienceList = []
var experienceCtrl = {
  init: function () {
    experienceCtrl.render()
  },
  render: function () {
    experienceCtrl.renderNovel()
    experienceCtrl.renderNews()
    experienceCtrl.renderHumancomputer()
  },
  renderNovel: function () {
    var containerId = 'novel_experience'
    var experience = new Experience({
      playBtn: `#${containerId} .js-base-play`
    })
    experienceList.push(experience)
    let putonghuaSpeakerDOMStr = experienceCtrl.getSpeakersDOMStr(exLists.novel.putonghua || [], {
      key: 'putonghua',
      value: '普通话'
    })
    let otherSpeakerDOMStr = experienceCtrl.getSpeakersDOMStr(exLists.novel.other || [], {
      key: 'other',
      value: '方言及其他'
    })
    $(`#${containerId} .swiper-container`).append(putonghuaSpeakerDOMStr + otherSpeakerDOMStr)
    experienceCtrl.voiceControl(`#${containerId} .voice`, experience)
    experienceCtrl.speedControl(`#${containerId} .speed`, experience)
    experienceCtrl.pitchControl(`#${containerId} .pitch`, experience)
    experienceCtrl.bindEventNovel(experience)
  },
  renderNews: function () {
    var containerId = 'news_experience'
    var experience = new Experience({
      playBtn: `#${containerId} .js-base-play`
    })
    experienceList.push(experience)
    let newsSpeakerDOMStr = experienceCtrl.getSpeakersDOMStr(exLists.news)
    $(`#${containerId} .swiper-container`).append(newsSpeakerDOMStr)
    experienceCtrl.voiceControl(`#${containerId} .voice`, experience)
    experienceCtrl.speedControl(`#${containerId} .speed`, experience)
    experienceCtrl.pitchControl(`#${containerId} .pitch`, experience)
    experienceCtrl.bindEventNews(experience)
  },
  renderHumancomputer: function () {
    var containerId = 'humancomputer_experience'
    var experience = new Experience({
      playBtn: `#${containerId} .js-base-play`
    })
    experienceList.push(experience)
    let humancomputerSpeakerDOMStr = experienceCtrl.getSpeakersDOMStr(exLists.humancomputer)
    $(`#${containerId} .swiper-container`).append(humancomputerSpeakerDOMStr)
    experienceCtrl.voiceControl(`#${containerId} .voice`, experience)
    experienceCtrl.speedControl(`#${containerId} .speed`, experience)
    experienceCtrl.pitchControl(`#${containerId} .pitch`, experience)
    experienceCtrl.bindEventHumancomputer(experience)
  },
  getSpeakersDOMStr: function (speakers, type = {}) {
    let speakerDOMStr = ``
    let speakerNumPreSlide = 10
    for (let i = 0; i < speakers.length; i++) {
      if (i % speakerNumPreSlide === 0) {
        speakerDOMStr += `<div class="swiper-wrapper" data-type=${type.value}><ul class="swiper-slide">`
      }
      speakerDOMStr += `
      <li class="speaker" data-index="${i}" data-type="${type.key}">
        <div class="speaker-img speaker-img-${speakers[i].photoType}">
          <img src="/hera/img/speaker-photo/small/${speakers[i].photo}" />
          ${speakers[i].tag ? `<i class="speaker-tag">${speakers[i].tag}</i>` : ''}
        </div>
        <span class="speaker-name"><span>${speakers[i].name}</span></span>
        <span class="speaker-desc">${speakers[i].desc}</span>
      </li>
      `
      if (i % speakerNumPreSlide === 9 || i === speakers.length - 1) {
        speakerDOMStr += `</ul></div>`
      }
    }
    return speakerDOMStr
  },
  voiceControl: function (container, ex) {
    $.fn.jSlider({
      renderTo: $(`${container} .js-slider`),
      initPosition: 7 / 10 * 70,
      size: {
        barWidth: 70,
        sliderWidth: 5
      },
      onChanging: function (voice, e) {
        experienceCtrl.changeVoice(voice, container, ex)
      }
    })
    experienceCtrl.changeVoice(7, container, ex)
  },
  speedControl: function (container, ex) {
    $.fn.jSlider({
      renderTo: $(`${container} .js-slider`),
      initPosition: 35,
      size: {
        barWidth: 70,
        sliderWidth: 5
      },
      onChanging: function (speed, e) {
        experienceCtrl.changeSpeed(speed, container, ex)
      }
    })
    experienceCtrl.changeSpeed(2, container, ex)
  },
  pitchControl: function (container, ex) {
    $.fn.jSlider({
      renderTo: $(`${container} .js-slider`),
      initPosition: 35,
      size: {
        barWidth: 70,
        sliderWidth: 5
      },
      onChanging: function (pitch, e) {
        experienceCtrl.changePitch(pitch, container, ex)
      }
    })
    experienceCtrl.changePitch(2, container, ex)
  },
  changePitch: function (pitch, container, ex) {
    let pitchList = [{
      value: '最慢',
      key: 0
    }, {
      value: '较慢',
      key: 25
    }, {
      value: '正常',
      key: 50
    }, {
      value: '较快',
      key: 75
    }, {
      value: '最快',
      key: 100
    }]
    // spd--语速（x-slow、slow、medium、fast、x-fast、default，或者设0-10之间的整数）
    pitch = pitch <= 1 ? Math.floor(pitch * pitchList.length) : pitch
    if (pitch === pitchList.length) {
      pitch = pitch - 1
    }
    $(`${container} .js-slider-text`).text(pitchList[pitch].value)
    ex.setConfig({pitch: pitchList[pitch].key})
  },
  changeSpeed: function (speed, container, ex) {
    let speedList = [{
      value: '最慢',
      key: 0
    }, {
      value: '较慢',
      key: 25
    }, {
      value: '正常',
      key: 50
    }, {
      value: '较快',
      key: 75
    }, {
      value: '最快',
      key: 100
    }]
    // spd--语速（x-slow、slow、medium、fast、x-fast、default，或者设0-10之间的整数）
    speed = speed <= 1 ? Math.floor(speed * speedList.length) : speed
    if (speed === speedList.length) {
      speed = speed - 1
    }
    $(`${container} .js-slider-text`).text(speedList[speed].value)
    ex.setConfig({speed: speedList[speed].key})
  },
  changeVoice: function (voice, container, ex) {
    // vol--音量（silent、x-soft、soft、medium、loud、x-loud、default、或者设0-10之间的整数）
    voice = voice <= 1 ? Math.floor(voice * 9) + 1 : voice
    $(`${container} .js-slider-text`).text(voice)
    ex.setConfig({voice})
  },
  changeText: function (text, ex) {
    ex.setConfig({text})
  },
  bindEventNovel: function (exNovel) {
    var swiper = new Swiper('#novel_swiper_speaker', {
      direction: 'vertical',
      pagination: '#novel_swiper_speaker .swiper-pagination',
      paginationClickable: true,
      mousewheelControl: true,
      observer: true,
      observeParents: true,
      onSlideChangeEnd: function (swiper) {
        let type = $('#novel_swiper_speaker .swiper-wrapper').eq(swiper.activeIndex).data('type')
        $('#novel_speaker_type').text(type)
      }
    })
    $('#novel_experience').on('click', '.speaker', function () {
      $('#novel_swiper_speaker .speaker.active').removeClass('active')
      $(this).addClass('active')
      let index = $(this).data('index')
      let type = $(this).data('type')
      let exSpeakerLists = exLists.novel
      let speaker = exSpeakerLists[type][index]
      let defaultText = speaker.text || DEFAULT_TEXT
      $('#novel_experience textarea').val(speaker.text).keyup() // .prop('placeholder', defaultText)
      exNovel.setConfig({
        engineType: speaker.engineType,
        voiceName: speaker.enName,
        text: speaker.text || '',
        defaultText: defaultText
      })
    }).on('change', 'textarea', function () {
      var text = this.value || ''
      exNovel.setConfig({text})
      $(this).keyup()
    }).on('keyup', 'textarea', function () {
      var len = this.value.length
      $(this).next().text(`${len}/200`)
      len && exNovel.resetAudio()
    }).on('click', '.js-base-play', function () {
      if ($(this).hasClass('play')) {
        exNovel.audioPause()
      } else {
        experienceCtrl.stopAllAudio()
        exNovel.audioPlay()
      }
    })
    $('#novel_swiper_speaker .speaker:eq(0)').click()
  },
  bindEventNews: function (exNews) {
    let exSpeakerLists = exLists.news
    if (exSpeakerLists.length > 10) {
      var swiper = new Swiper('#news_swiper_speaker', {
        direction: 'vertical',
        pagination: '#news_swiper_speaker .swiper-pagination',
        paginationClickable: true,
        mousewheelControl: true,
        observer: true,
        observeParents: true
      })
    }
    experienceCtrl.bindEventItem('news_experience', exNews, exSpeakerLists)
  },
  bindEventHumancomputer: function (exHumancomputer) {
    let exSpeakerLists = exLists.humancomputer
    if (exSpeakerLists.length > 10) {
      var swiper = new Swiper('#humancomputer_swiper_speaker', {
        direction: 'vertical',
        pagination: '#humancomputer_swiper_speaker .swiper-pagination',
        paginationClickable: true,
        mousewheelControl: true,
        observer: true,
        observeParents: true
      })
    }
    experienceCtrl.bindEventItem('humancomputer_experience', exHumancomputer, exSpeakerLists)
  },
  bindEventItem: function (containerId, ex, exSpeakerLists) {
    $(`#${containerId}`).on('click', '.speaker', function () {
      $(`#${containerId} .speaker.active`).removeClass('active')
      $(this).addClass('active')
      let index = $(this).data('index')
      let speaker = exSpeakerLists[index]
      let defaultText = speaker.text || DEFAULT_TEXT
      $(`#${containerId} textarea`).val(speaker.text).keyup()
      ex.setConfig({
        engineType: speaker.engineType,
        voiceName: speaker.enName,
        text: speaker.text || '',
        defaultText: defaultText
      })
    }).on('change', 'textarea', function () {
      var text = this.value || ''
      ex.setConfig({text})
      $(this).keyup()
    }).on('keyup', 'textarea', function () {
      var len = this.value.length
      $(this).next().text(`${len}/200`)
      len && ex.resetAudio()
    }).on('click', '.js-base-play', function () {
      if (ex.playState === 'play') {
        ex.audioPause()
      } else {
        experienceCtrl.stopAllAudio()
        ex.audioPlay()
      }
    })
    $(`#${containerId} .speaker:eq(0)`).click()
  },
  stopAllAudio: function () {
    experienceList.map((item) => {
      item.audioPause()
    })
  }
}
export default experienceCtrl



// WEBPACK FOOTER //
// ./src/js/libs/utils-tts-read-solution.js